export const SET_SELECTED_ORDER_IDS = 'SET_SELECTED_ORDER_IDS'
export const SET_ORDERS = 'SET_ORDERS'
export const SET_TARGET_ORDER_ID = 'SET_TARGET_ORDER_ID'
